import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/design-tokens.css';
import '@cloudsam/ui/dist/styles.css'; // shared shell + components; must follow the tokens
import './styles/app-base.css';
import './hanko-init'; // Must be imported before App
import App from './App';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import IdleSessionGate from './components/IdleSessionGate';

// Surface identity (surface-identity-and-shell.md §1): the tint is declared once
// on the app root and inherited by every panel via --color-surface-*. Set on the
// #root element rather than a JSX wrapper so portalled overlays that mount inside
// #root inherit it too.
const rootEl = document.getElementById('root');
rootEl.classList.add('app--console');

const root = ReactDOM.createRoot(rootEl);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <ProtectedRoute>
                {/* Inside ProtectedRoute, so the idle clock only runs for
                    somebody who is actually signed in. */}
                <IdleSessionGate>
                    <App />
                </IdleSessionGate>
            </ProtectedRoute>
        </AuthProvider>
    </React.StrictMode>
);
